﻿import { ApiCaller } from 'apis/ApiCaller';

export interface Instructor {
	AddUsersPermission?: boolean;
	EmailAddress: string;
	FirstName: string;
	Id: number;
	IsActive?: boolean;
	LastName: string;
	LoginId?: string;
	ManageFullGroup?: boolean;
	RoleId?: number;
	UserName: string;

}

/**
 * Represents an api handler for the InstructorController in Areas/Api/Controllers.
 * */
export class InstructorApi {

    private static apiCaller = new ApiCaller('Instructor');

    public static GetAll(): Promise<Instructor[]> {

	    return this.apiCaller.GET<Instructor[]>('GetAll');

    }

    public static Get(groupId: number){

	    return this.apiCaller.GET<Instructor[]>('Get', { groupId });

    }

}